import React from 'react';
import { Star, ArrowUpRight, Sparkles } from 'lucide-react';
import { testimonials, socialLinks } from '../../data/mock';

export default function Testimonials() {
  return (
    <section className="py-20 md:py-24 bg-splash-creamDark" data-testid="home-testimonials">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">
              <Sparkles className="w-3.5 h-3.5" /> Loved by Families
            </div>
            <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green leading-tight">What parents are saying</h2>
          </div>
          <a
            href={socialLinks.googleReviews}
            target="_blank"
            rel="noreferrer"
            data-testid="testimonials-google-reviews-link"
            className="self-start md:self-auto inline-flex items-center gap-2 rounded-full bg-white border border-splash-sand text-splash-green px-5 py-3 text-sm font-semibold btn-transition hover:border-splash-coral"
          >
            <span className="flex gap-0.5">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-splash-mustard text-splash-mustard" />)}
            </span>
            Read &amp; leave a Google review <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <figure key={t.name} data-testid={`testimonial-card-${idx}`} className="bg-white rounded-3xl p-8 border border-splash-sand card-hover flex flex-col">
              <div className="flex gap-0.5 mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-splash-coral text-splash-coral" />
                ))}
              </div>
              <blockquote className="text-splash-green/85 leading-relaxed flex-1">&ldquo;{t.text}&rdquo;</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-splash-teal/20 grid place-items-center text-splash-teal font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-splash-green text-sm">{t.name}</div>
                  <div className="text-xs text-splash-green/60">Little Splash parent</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
